
import TrackerTable from './tracker-table.vue'
import TrackerModal from './tracker-modal.vue'

export default {
  components: {TrackerTable, TrackerModal},
  props: {
    widget: {type: Object, required: true}
  },
  data: () => ({mount_modal: false}),
  methods: {
    expand() {
      this.mount_modal = true
      this.$nextTick(() => this.$refs.modal.open())
    }
  }
}
